export const paginationPageStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 600,
};
